import { useState, useEffect } from 'react';
import styled from 'styled-components';
import { Search, Button, Loading } from 'carbon-components-react';

import { Container, ContentContainer } from '../../components/Wrapper/Wrapper';

import TileHeader from '../../components/TileHeader/TileHeader';
import ConfirmModal from '../../components/Modal/ConfirmModal';
import InterventionsGrid from './InterventionsGrid';
import InterventionDetailModal from './InterventionDetailModal';

import { getAllInterventions, deleteIntervention } from '../../api/interventions';

import { toaster } from '../../helpers/toaster';
import usePollReport from '../../hooks/usePollReport';
import { triggerReport } from '../../api/studyListApi';

const Interventions = () => {
	// loading is for initial component preloading
	const [loading, setLoading] = useState(false);

  const [interventionList, setInterventionList] = useState([]);
  const [search, setSearch] = useState("");
  const [searchGrid, setSearchGrid] = useState("");
  const [openInterventionModal, setInterventionModalStatus] = useState(false);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [deleteItemId, setDeleteItemId] = useState(null);
  const [deleteItemName, setDeleteItemName] = useState("");
  const [refreshData, setRefreshData] = useState(false);
  const [sort, setSort] = useState("")

  // modal params
  const [modalInterventionName, setModalInterventionName] = useState("");
  const [modalSynonyms, setModalSynonyms] = useState([]);
  const [modalRootIntervention, setModalRootIntervention] = useState([]);
  const [modalStudies, setModalStudies] = useState([]);
  const [detailModalMode, setDetailModalMode] = useState("");
  const [interventionId, setInterventionId] = useState(null);

  const onlyAttachment = localStorage.getItem('only_attachment')

  const { startPolling, status: reportStatus } = usePollReport({
    onSuccess: () => { toaster('Interventions report downloaded successfully', 'success'); },
    onError: () => toaster('Failed to generate report. Please try again.', 'error'),
  });

  const [openReportModal, setOpenReportModal] = useState(false);

  const handleGenerateReport = () => {
    setOpenReportModal(false);
    triggerReport('interventions')
      .then(({ task_id }) => {
        toaster('Generating interventions report...', 'info');
        startPolling(task_id);
      })
      .catch(() => toaster('Failed to start report generation.', 'error'));
  };


  const addInterventionBtnStyle = {
    padding: "11px 18px",
    height: "auto",
    minHeight: "unset",
    borderRadius: "10px",
    fontFamily: "'Plus Jakarta Sans', system-ui, sans-serif",
    fontWeight: 700,
    fontSize: "13.5px",
  };

  useEffect(() => {
    const timeout = setTimeout(() => {
      setSearchGrid(search);
    }, 1000)
    // if this effect run again, because `value` changed, we remove the previous timeout
    return () => clearTimeout(timeout)
  }, [search]);
  // useEffect(() => {
  //   getInterventions();
  // }, []);

  // const getInterventions = () => {
  //   setLoading(true);
  //   getAllInterventions().then(items => {
  //     items = items.map(item => ({
  //       ...item,
  //       synonymsText: (item.synonyms || []).slice(0, 5).join(", "),
  //       studiesText: (item.studies || []).map(ele => ele.org_study_id).slice(0, 2).join(", "),
  //     }));
  //     setInterventionList(items);
  //     setLoading(false);
  //   });
  // };

  const addNewIntervention = () => {
    setDetailModalMode("create");
    setModalInterventionName("");
    setModalSynonyms([]);
    setModalStudies([]);
    setModalRootIntervention([]);

    setInterventionModalStatus(true);
  };

  const interventionRowClicked = (data) => {
    setDetailModalMode("update");
    setInterventionId(data.id);
    setModalInterventionName(data.name || "");

    let synIds = [];
    let syns = [];
    if (data.synonyms && data.synonyms.length) {
      syns = data.synonyms.map(syn=> ({label: syn, value: syn}))
    }
    setModalSynonyms(syns);

    let studyIds = [];
    if (data.studies && data.studies.length) {
      studyIds = data.studies.map(study => study.id);
    }
    setModalStudies(studyIds);

    let rootCond = [];
    if (data.root_intervention && data.root_intervention.length) {
      rootCond = data.root_intervention.map(cond => cond.id);
    }
    setModalRootIntervention(rootCond);

    setInterventionModalStatus(true);
  };

  const showDeleteConfirm = (itemId, itemName) => {
    setOpenDeleteModal(true);
    setDeleteItemId(itemId);
    setDeleteItemName(itemName || "");
  };

  const confirmDelete = () => {
    setOpenDeleteModal(false);
    setLoading(true);
    deleteIntervention(deleteItemId).then(res => {
      toaster("Intervention deleted successfully", "success")
      setLoading(false);
      setRefreshData(true);
      // getInterventions();
    });
  };
  const refreshTriggered = () => {
    setRefreshData(true);
  }

  return (
    <Container>
      <ContentContainer>

        <TileHeader
            title="Interventions"
            // subtitle="A list of all interventions. To add a Intervention click the ‘Add Intervention’ button. Edit Intervention values directly in the table."
            size="lg"


        />
        {
					loading ?
					<Loading

          />
					:
					<></>
				}

        <InterventionsContent>
          <ActionBar>
            <div style={{ width: "300px" }}>
              <Search
                size="sm"
                value={search}
                labelText="search"
                onChange={e => setSearch(e.target.value)}
                placeHolderText="Search using any data value"/>
            </div>

            <ButtonGroup>
              <Button
                kind="secondary"
                onClick={() => setOpenReportModal(true)}
                disabled={reportStatus === 'polling'}
                style={addInterventionBtnStyle}
              >{reportStatus === 'polling' ? 'Generating...' : 'Generate Report'}</Button>
              <Button
                kind="primary"
                onClick={() => addNewIntervention()}
                style={addInterventionBtnStyle}
                disabled={onlyAttachment === "true"}
              >Add Intervention</Button>
            </ButtonGroup>
          </ActionBar>

          <InterventionsGrid
            interventionList={interventionList}
            search={searchGrid}
            onRowClicked={interventionRowClicked}
            onDeleteClicked={showDeleteConfirm}
            setRefresh={setRefreshData}
            refresh={refreshData}
            sort={sort}
            setSort={setSort}
          />
        </InterventionsContent>

        <InterventionDetailModal
          mode={detailModalMode}
          interventionId={interventionId}
          open={openInterventionModal}
          name={modalInterventionName}
          synonyms={modalSynonyms}
          parentIntervention={modalRootIntervention}
          studies={modalStudies}
          refreshInterventions={refreshTriggered}
          onClose={() => setInterventionModalStatus(false)}
          refreshData={refreshData}
        />

        <ConfirmModal
          title="Confirmation"
          content={`Are you sure you want to delete the intervention "${deleteItemName}"?`}
          open={openDeleteModal}
          onClose={() => setOpenDeleteModal(false)}
          onConfirm={() => confirmDelete()}
        />
        <ConfirmModal
          title="Generate Report"
          content="Do you want to generate the report? This may take awhile. Navigating away from this page will stop the report generation."
          open={openReportModal}
          onClose={() => setOpenReportModal(false)}
          onConfirm={handleGenerateReport}
        />

      </ContentContainer>
    </Container>
  );
};

export default Interventions;

const InterventionsContent = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 22px 24px;
  background-color: #fff;
  border: 1px solid #e7eaf0;
  border-radius: 14px;
  box-shadow: 0 1px 3px rgba(0,0,0,.04);
`

const ActionBar = styled.div`
  width: 100%;
  height: fit-content;
  background-color: #fff;
  margin-bottom: 16px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`

const ButtonGroup = styled.div`
  display: flex;
  gap: 8px;
`

const InterventionsFooter = styled.div`
  width: 100%;
  height: fit-content;
  background-color: #fff;
  padding: 0px 20px 20px 20px;
  margin-bottom: 30px;
  display: flex;
  flex-direction: row;
  align-items: center;
`
